import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Get } from '../lib/User';

const LEVEL_CLASS = {
  1: 'warning_yellow_pop',
  2: 'warning_red_pop',
  3: 'warning_red_pop',
};

const LEVEL_TITLE = {
  1: '주의',
  2: '경고',
  3: '위험',
};

// code만 들어올 때를 대비한 기본 사유 매핑(원하시는 문구로 수정하세요)
const REASON_BY_CODE = {
  HR_OUT_OF_RANGE: '심박수가 정상 범위를 벗어났습니다.',
  RR_OUT_OF_RANGE: '호흡수가 정상 범위를 벗어났습니다.',
  APNEA: '무호흡이 감지되었습니다.',
  LEVEL1_PERSIST_30M: '이상 상태가 30분 이상 지속되고 있습니다.',
  NO_MOTION_8H_WHILE_USE: '사용 중 상태에서 장시간 움직임이 감지되지 않았습니다.',
  LEVEL1_GENERIC: '이상 생체신호를 확인했습니다.',
};

const PopupWarnning = (props) => {
  const { t } = useTranslation();
  const popup = props.popup;

  const [data, setData] = useState(null);

  useEffect(() => {
    if (!popup?.member_no) return;

    Get(popup.member_no, (res) => {
      setData(res);
    });
  }, [popup?.member_no]);

  if (!popup || !data) return null;

  const level = popup.level ?? 1;
  const title = popup.name || LEVEL_TITLE[level] || t('알림');

  // ✅ 사유 우선순위: popup.message -> code 매핑 -> 기본문구
  const reason =
    popup.message ||
    REASON_BY_CODE[popup.code] ||
    '이상 생체신호를 확인했습니다.';

  const occurredAtText = popup.occurredAt
    ? new Date(popup.occurredAt).toLocaleString()
    : '';

  return (
    <section className={`popup_wrap ${LEVEL_CLASS[level]} show`}>
      <div className="pop_base">
        <button type="button" className="btn_close" onClick={props.onClose}>
          {t('닫기')}
        </button>

        <div className="icons alert"></div>

        <div className="in_box">
          <p className="alert_tit">{t(title)}</p>

          {/* ✅ 사유(원인) */}
          <p className="tit">{t(reason)}</p>

          {/* ✅ 연락처/보호자 연락처 제거, 회원명만 남김 */}
          <ul className="info_list">
            <li>
              {t('회원명')} : {data.name}
            </li>
          </ul>

          {/* 발생 시각 */}
          {occurredAtText ? (
            <p className="subtext">{`${t('발생 시각')} : ${occurredAtText}`}</p>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default PopupWarnning;
